import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

interface ErrorDialogData {
  title?: string;
  message: string;
  link?: string;
  linkText?: string;
}

@Component({
    selector: 'app-error-dialog',
    styleUrls: ['./error-dialog.component.css'],
    templateUrl: './error-dialog.component.html',
    standalone: false
})
export class ErrorDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: ErrorDialogData) { }

  openLink(): void {
    if (this.data.link) {
      window.open(this.data.link, '_blank');
    }
  }
}
